module.exports = __webpack_public_path__ + "img/settings.f5f7b060.svg";